import './Contact.css';
import emailjs from "emailjs-com";
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faYoutube,
  faInstagram,
  faFacebook,
  faXTwitter,
  faRedditAlien
} from '@fortawesome/free-brands-svg-icons';

export const Contact = () => {
  // Handle form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      "service_zm7m1du",
      "template_ciuflhr",
      formData,
      "YY5Xzr5K-TseMhH3L"
    )
      .then(() => {
        alert("Thank you for contacting us! We’ll get back to you shortly.");
        setFormData({ name: "", email: "", subject: "", message: "" });
      })
      .catch((error) => {
        //alert("Something went wrong. Please try WhatsApp.");
        console.error("EmailJS Error:", error);
        alert(error.text || "EmailJS failed");
      });
  };

  // Handle form changes
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  return (
    <section className="contact-page">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card">
              <h3>📧 Email Us</h3>
              <p><a href="mailto:info@qinto.in">info@qinto.in</a></p>
            </div>
            <div className="info-card">
              <h3>🆘 Support</h3>
              <p><a href="mailto:info@qinto.in">support@qinto.in</a></p>
            </div>
            <div className="info-card">
              <h3>📱 Follow Us</h3>
              <div className="social-links">
                <a href="https://www.youtube.com/@qintoapp" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a href="https://x.com/qintoapp" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                  <FontAwesomeIcon icon={faXTwitter} />
                </a>
                <a href="https://instagram.com/qinto.in" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FontAwesomeIcon icon={faInstagram} size="2x" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61585049194040" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FontAwesomeIcon icon={faFacebook} size="2x" />
                </a>
                <a href="https://reddit.com/r/qinto" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
                  <FontAwesomeIcon icon={faRedditAlien} />
                </a>
              </div>
            </div>



            <div className="info-card whatsapp-card">
              <h3>💬 Chat on WhatsApp</h3>
              <p>Get instant support from our team</p>
              <a
                href="https://wa.me/916305066105?text=Hi%20Qinto%20Team%2C%20I%20need%20help"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
                Start WhatsApp Chat
              </a>
            </div>

          </div>

          <form onSubmit={handleFormSubmit} className="contact-form">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleFormChange}
                required
                placeholder="Your Name"
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleFormChange}
                required
                placeholder="your@email.com"
              />
            </div>
            <div className="form-group">
              <label>Subject</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleFormChange}
                required
                placeholder="Subject"
              />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleFormChange}
                required
                placeholder="Your message..."
                rows="5"
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );


};